import { CustomerInfo, Query } from '@varo/graphql-schema-types';
import { useCallback } from 'react';
import GetProfileInfo from 'services/graphql/queries/GetProfileInfo';
import { CombinedError, RequestPolicy, useQuery } from 'urql';

interface ProfileResult {
  userId: string;
  customerInfo: CustomerInfo;
}

interface ProfileInfo {
  result?: ProfileResult;
  error?: CombinedError;
  fetching: boolean;
  refetch: (requestPolicy?: RequestPolicy) => void;
}

const useGetProfileInfo = (
  requestPolicy: RequestPolicy = 'network-only',
): ProfileInfo => {
  const [response, refetchData] = useQuery<Query>({
    query: GetProfileInfo,
    requestPolicy,
  });

  const refetch = useCallback(
    (requestPolicy: RequestPolicy = 'network-only'): void => {
      refetchData({
        requestPolicy,
      });
    },
    [refetchData],
  );

  const { data, fetching, error } = response;

  const responseResult: ProfileResult | undefined = data?.user
    ? {
        userId: data.user.id,
        customerInfo: data.user.customerInfo || ({} as CustomerInfo),
      }
    : undefined;

  return {
    result: responseResult,
    fetching,
    error,
    refetch,
  };
};

export default useGetProfileInfo;
